<template>
	<div>
		<!-- <i class="fas fa-cogs pointer fa-2x text-success" @click.stop="changeGridSettings" data-toggle="tooltip" :title="$t('buttons.settings.tooltipText')"></i> -->
		<grid-user-settings
			ref="userSettings"
			:schemaModelFields="schemaModelFields"
			:componentName="componentName"
			:useLabelAsTitle="true"
			:showUserSettings="true"
			:gridOptions="userSettings"
			v-if="visible"
			@saveGridSettings="saveGridSettings"
			@loadGridSettings="loadGridSettings"
			@deleteGridSettings="deleteGridSettings"
			@userSettingsChanged="userSettingsChanged"
		></grid-user-settings>
	</div>
</template>

<script>
import personalizationService from '../../services/personalization.service';
import GridUserSettings from './UserSettings';
import { Culture, KendoGridPageSize } from '../../models/enums';

export default {
	props: {
		grid: {
			type: Object,
			required: false
		},
		componentName: {
			type: String,
			required: true
		},
		visible: {
			type: Boolean,
			required: true
		},
		schemaModelFields: {
			type: Object
		}
	},
	components: {
		'grid-user-settings': GridUserSettings
	},
	data() {
		return {
			customSettingsLoaded: false
		};
	},
	methods: {
		//This is needed for grid state save and mass search
		getGridOptions() {
			const grid = this.grid.kendoWidget();
			if (grid) {
				return grid.getOptions();
			}
		},
		saveGridSettings() {
			const gridSettings = this.getGridOptions();
			const grid = this.grid.kendoWidget();

			if (gridSettings && grid) {
				this.$refs.userSettings.setGridSettings(gridSettings);

				personalizationService
					.saveGridSettings(this.componentName, gridSettings)
					.then(response => {
						this.$vs.notify({
							title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
							text: this.$helpers.responseMessage(response),
							color: 'success',
							time: this.$store.getters.notificationDuration
						});
					})
					.catch(error => {
						this.$vs.notify({
							title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
							text: this.$helpers.errorText(error),
							color: this.$helpers.errorColor(error),
							time: this.$store.getters.notificationDuration
						});
					});
			}
		},
		loadGridSettings() {
			personalizationService
				.loadGridSettings(this.componentName)
				.then(response => {
					try {
						var options = personalizationService
							.mergePersonGridSettings(this.getGridOptions(), response.data.settings);

						let grid = this.grid.kendoWidget();
						if (options && grid) {
							grid.setOptions(options);

							if (options.pageable.size != grid.dataSource.options.pageSize) {
								grid.dataSource.pageSize(options.pageable.size);
								grid.refresh();
							}

							const userSettingsEditor = this.$refs.userSettings;
							if (userSettingsEditor) {
								userSettingsEditor.setGridSettings(grid.getOptions());
							}
						}

						this.customSettingsLoaded = true;
					} catch (e) {
						this.customSettingsLoaded = true;
					}
				})
				.catch(error => {
					this.customSettingsLoaded = true;

					this.$vs.notify({
						title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
						text: this.$helpers.errorText(error),
						color: 'danger',
						time: this.$store.getters.notificationDuration
					});
				});
		},
		deleteGridSettings() {
			personalizationService
				.delteGridSettings(this.componentName)
				.then(response => {
					this.$router.go();
				})
				.catch(error => {
					this.$vs.notify({
						title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
						text: this.$helpers.errorText(error),
						color: this.$helpers.errorColor(error),
						time: this.$store.getters.notificationDuration
					});
				});
		},
		userSettingsChanged(userSettings, pageSizeChanged) {
			let grid = this.grid.kendoWidget();

			if (grid) {
				try {
					grid.setOptions(userSettings);
					if (pageSizeChanged === true) {
						if (userSettings.pageable.size == KendoGridPageSize.All) {
							console.log('try set grid total: ', grid.dataSource.total());

							grid.dataSource.pageSize(grid.dataSource.total());
						} else {
							grid.dataSource.pageSize(userSettings.pageable.size);
						}
						this.grid.refresh();
					}
				} catch (e) {
					return;
				}
			}
		},
		saveState() {
			personalizationService.saveState(this.componentName, this.getGridOptions());
		},
		loadState: function() {
			let stateSettings = personalizationService.getState(this.componentName);
			let options = personalizationService.mergeStateSettings(this.getGridOptions(), stateSettings);
			if (options) {
				let grid = this.grid.kendoWidget();
				if (grid) {
					grid.setOptions(options);
				}
			}
		},
		changeGridSettings() {
			this.showUserSettingsForm = !this.showUserSettingsForm;
		},
		clearFilters() {
			personalizationService.claerState(this.componentName);

			this.searchQuery = '';
			const grid = this.grid.kendoWidget();
			if (grid) {
				grid.dataSource.sort({});
				grid.dataSource.page(1);
				grid.dataSource.aggregate([]);
				grid.dataSource.filter({});
			}
		}
	},
	computed: {
		token: function() {
			return this.$store.getters.authToken;
		},
		isEnVersion() {
			return this.$store.getters.currentCulture === Culture.EN;
		},
		userSettings() {
			let grid = this.grid.kendoWidget();
			return grid.getOptions();
		},
		toolbar: function() {
			return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }];
		}
	},
	mounted() {
		if (this.grid) {
			console.log('loading grid settings on mounted...');
			this.loadGridSettings();
		}
	},
	watch: {
		grid: function(val) {
			if (val) {
				console.log('loading grid settings on change...');

				this.loadGridSettings();
			}
		}
	}
};
</script>

<style>
</style>
